//첫 페이지

import imgMain1 from '../images/home/img_main1.png';
import imgMain2 from '../images/home/img_main2.png';
import React, { useEffect, useState } from 'react';

import iconArrowDown from '../images/home/icon_arrow_down.png';
import mainLogoCon from '../images/home/main_logoCon.png';

import { useInterval, zeroPad } from '../function/common';
import { Link, useHistory } from 'react-router-dom';

function Home() {
    return (
        <div id="home">
            <div className="visual">
                <div className="textCon">
                    <p className="strongT eng">
                        <span>PLAY</span>API
                    </p>
                    <span className="eng">PLAYAPI</span> 연동 한 번으로 쇼핑몰 연동 신규개발, 유지보수 걱정없이
                    <br /> 국내 외 120여개 쇼핑몰을 연동할 수 있습니다.
                </div>
            </div>
            <div className="bg-lightGray">
                <div className="contents">
                    <h3>
                        쇼핑몰 연동이 필요할 땐&nbsp;
                        <span className="eng">
                            <span className="colorPrimary">PLAY</span>API !
                        </span>
                    </h3>
                    <FullSlide
                        data={[
                            '상품 등록',
                            '상품 수정',
                            '상품 품절',
                            '상품 복구',
                            '주문 수집',
                            '송장 전송',
                            '주문 동기화',
                            '고객 문의 수집',
                            '답변 전송',
                            '상품평 수집',
                            '긴급메세지 수집',
                        ]}
                    ></FullSlide>
                </div>
            </div>
            <div className="contents">
                <h3>
                    <span className="eng">
                        <span className="colorPrimary">PLAY</span>API&nbsp;
                    </span>
                    연동 제휴사
                </h3>
                <p>국내외 120여개 쇼핑몰 지원. 연동 쇼핑몰은 계속 추가되고 있습니다.</p>
                <img src={mainLogoCon} alt="연동쇼핑몰" />
            </div>
            <div className="contact bg-lightGray">
                <p className="icon-icon_mail"></p>
                <p className="title">담당자 메일 주소</p>
                제휴문의
                <span className="eng">
                    E-mail{' '}
                    <span>
                        | <a href="mailto:playapi@playauto.co.kr">playapi@playauto.co.kr</a>
                    </span>
                </span>
            </div>
        </div>
    );
}

const FullSlide = ({ data }: any) => {
    const [active, setActive] = useState(2);

    const history = useHistory();

    // 슬라이드 자동 애니메이션
    useInterval(() => {
        const changeActive = limitReturn(active + 1);

        setActive(changeActive);
    }, 1500);

    // 범위내 카운트로 변환 함수
    const limitReturn = (count: number) => {
        if (data.length <= count) {
            count = count - data.length;
        } else if (count < 0) {
            count = data.length - Math.abs(count);
        }

        return count;
    };

    return (
        <div className="funcSlide">
            <ul>
                {data.map((one: string, key: number) => {
                    const maxWidth = 1220;
                    const oneWidth = maxWidth / 5;

                    // 1220
                    let leftOne = -230;
                    let transition = '0.3s';

                    if (key == limitReturn(active - 2)) {
                        leftOne = oneWidth * 0;
                    } else if (key == limitReturn(active - 1)) {
                        leftOne = oneWidth * 1;
                    } else if (key == active) {
                        leftOne = oneWidth * 2;
                    } else if (key == limitReturn(active + 1)) {
                        leftOne = oneWidth * 3;
                    } else if (key == limitReturn(active + 2)) {
                        leftOne = oneWidth * 4;
                    } else if (key == limitReturn(active + 3)) {
                        leftOne = oneWidth * 5;
                        transition = 'none';
                    } else if (key == limitReturn(active + 4)) {
                        leftOne = oneWidth * 6;
                        transition = 'none';
                    } else {
                        transition = 'none';
                    }

                    return (
                        <li
                            className={active == key ? 'active' : ''}
                            style={{ left: leftOne, transition: transition }}
                            key={key}
                            onClick={() => {
                                history.push({
                                    pathname: '/guide/playApiGuide',
                                    state: { scrollTargetId: 'provision' },
                                });
                            }}
                        >
                            <p className="iconArea">
                                <span className={`icon-main_icon${zeroPad(key + 1, 10)}`}></span>
                            </p>
                            <p className="funcText">{one}</p>
                        </li>
                    );
                })}
            </ul>
            <div className="btnArea">
                <button
                    className="prevBtn"
                    onClick={() => {
                        setActive(limitReturn(active - 1));
                    }}
                >
                    <span className="icon-arrow_left"></span>
                </button>
                <button
                    className="nextBtn"
                    onClick={() => {
                        setActive(limitReturn(active + 1));
                    }}
                >
                    <span className="icon-arrow_right"></span>
                </button>
            </div>
        </div>
    );
};

export default Home;
